
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  if(Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE){
    Flits(document).on("Flits:Loaded",function(event){
       if(window.flitsObjects.allCssJs.wishlistJs){
         Flits.LoadStyleScript('wishlistJs',window.flitsObjects.allCssJs.wishlistJs.url);
       }
    });
  }
  if(Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable && window.flitsObjects.storeData.customer_id != -1){
    if(window.flitsObjects.allCssJs.cartJs){
     Flits.LoadStyleScript('cartJs',window.flitsObjects.allCssJs.cartJs.url); 
    }
  }
   Flits(document).on('Flits:wishlistButton:Loaded', function(event){
     if(Flits.request.page_type == "index" || Flits.request.page_type == "collection" || Flits.request.page_type == "product"){
      let collectionBtn = Flits('.flits-wishlist-colection');
      parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
        Flits(collectionBtn).show();
        Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent'); 
     }
  });
  if(Flits.request.page_type !== "cart"){
    Flits(document).on("Flits:CartAutomaticCode:Loaded",function (event) {
      let data = event.detail;
      let el =  data.el;
      let parent =  data.parent;
      let cloneNode = data.cloneNode;
      parent.parent().attr("data-flits","store-credit-parent")
      parent.removeAttr("data-flits");
      parent.before(cloneNode);
    })
  }

}(Flits));
